import request from '@/utils/request'

/**
 * 修改eBlock
 * @param {*} eBlock
 * @returns
 */
export function updateBlock(eBlock) {
  return request({
    url: '/device/eblock',
    method: 'put',
    data: eBlock
  })
}
/**
 * 新增eBlock
 * @param {*} eBlock
 * @returns
 */
export function addBlock(eBlock) {
  return request({
    url: '/device/eblock',
    method: 'post',
    data: eBlock
  })
}

export function addBlockV3(eBlock) {
  return request({
    url: '/device/v3/eblock',
    method: 'post',
    data: eBlock
  })
}

/**
 * 修改eBlock（V3）
 * @param {*} eBlock
 * @returns
 */
export function updateBlockV3(eBlock) {
  return request({
    url: '/device/v3/eblock',
    method: 'put',
    data: eBlock
  })
}

/**
 * 获取eBlock列表
 * @param {*} pageNum
 * @param {*} pageSize
 * @param {*} stationId
 * @returns
 */
export function getEBlockList(pageNum, pageSize, stationId, parentEquipmentId) {
  return request({
    url: '/device/eblock/list',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      stationId,
      parentEquipmentId
    }
  })
}


/**
 * 批量删除eBlock
 * @param {*} equipmentIds
 * @returns
 */
export function delEBlock(equipmentIds) {
  return request({
    url: `/device/eblock/${equipmentIds}`,
    method: 'delete',
  })
}

/**
 * 批量删除eBlock（V3）
 * @param {*} equipmentIds
 * @returns
 */
export function delEBlockV3(equipmentIds) {
  return request({
    url: `/device/v3/eblock/${equipmentIds}`,
    method: 'delete',
  })
}


/**
 * 获取eBlock详细信息
 * @param {*} equipmentId
 */
export function getEBlock(equipmentId) {
  return request({
    url: `/device/eblock/${equipmentId}`,
    method: 'get',
  })
}





/////////////////////////////////////////////////// 100C 相关 /////////////////////////////////////////////////


/**
 * 查询遥调遥控的点表
 */
export function getSettingPointTableList() {
  return request({
    url: `/command/overseas/getSettingPointTableList`,
    method: 'get',
  })
}


/**
 * 获取最新的参数设置值
 * @param {string} uuid
 * @param {string} dataClassification
 */
export function getLatestData(uuid, dataClassification) {
  return request({
    url: `/command/overseas/getLatestData`,
    method: 'post',
    data: {
      uuid,
      dataClassification
    }
  })
}



// 设置参数
/**
 * 
 * @param {object} data 
 * @param {string} data.uuid 设备UUID
 * @param {string} data.dataClassification
 * @param {Array} data.list
 * @returns 
 */
export function propertySet(data) {
  return request({
    url: `/command/overseas/propertySet`,
    method: 'post',
    data
  })
}




/**
 * 根据sign查询设置结果
 * @param {string } sign sign通信序列码
 */
export function getSettingRecord(sign) {
  return request({
    url: `/command/overseas/getSettingRecord`,
    method: 'get',
    params: {
      sign
    }
  })
}



/**
 * @typedef {object} CurveDataParams
 * @property {string} date 数据日期，默认当天
 * @property {number|string} interval 数据间隔如：30(秒)、5(分钟)、1(一小时)、1(一天)、1(一个月)
 * @property {number|string} intervalType 数据间隔类型：0秒 1分钟 2小时 3天 4月
 * @property {number} stationId 电站Id  全部设备
 * @property {string[]|string} types 1SOC曲线  2电池功率曲线 3重要负载曲线 4充放电数据曲线 5负载曲线 6电能来源 7PV功率曲线
 * @property {string} [uuid] 设备UUid、单设备
 */


/**
 * 统一数据统计接口--新版
 * @param {CurveDataParams} params 
 */
export function getCurveData(params) {
  return request({
    url: `/solar/statistics/curve/getCurveData`,
    method: 'get',
    params: params
  })
}


/**
 * 配置参数
 * @param {object} params 配置参数
 * @param {string} params.stationId 设备ID
 * @param {string} params.equipmentSn 设备SN(uuid)
 * @returns 
 */
export function getNetworkConfigList(params) {
  return request({
    url: `/solar/equipment/network/config/queryList`,
    method: 'get',
    params: params
  })
}

/**
 * 100C设备最新数据
 * @param {object} params 
 * @param {string} params.stationId 电站Id
 * @param {string} params.devId 设备SN
 * @param {string} params.equipmentType 设备类型；0PCS 1BMS 2BCS 3BMU 4电池簇 5Fire(消防) 6Water（水机）
 * @param {string} params.dataType 数据类型；0遥测 1遥信
 */
export function getLatestData100C(params) {
  return request({
    url: `/dashboard/equipment/100C/eblock/getLatestData`,
    method: 'get',
    params: params
  })
}


/**
 * 获取光伏数据
 * @param {string} devIds 设备SN
 */
export function getPvData(devIds) {
  return request({
    url: `/dashboard/equipment/100C/pv/getPvData`,
    method: 'get',
    params: {
      devIds
    }
  })
}


/**
 * 100C生产概览
 * @param {object} params 
 * @param {string} params.stationId 电站Id
 * @param {string} params.startTime 开始时间
 * @param {string} params.endTime 结束时间
 * @param {string} params.type 类型  day、month、year
 */
export function getEnergyData(params) {
  return request({
    url: `/dashboard/equipment/100C/overview/getEnergyData`,
    method: 'get',
    params: params
  })
}


/**
 * 获取语言包
 * @param {*} language 语种 cn en fr de es ja ru it pt
 * @param {*} type APP-(app语言包) WEB-(语言包) INSTALL-(安装商) SERVER-(服务端响应)
 * @returns 
 */
export function getLanguageResourcePacket(language, type = 'APP') {
  return request({
    url: `/ecenter/system/language-resource/packet`,
    method: 'get',
    params: {
      language,
      type
    }
  })
}




/**
 * 主监控-左边充放电统计
 * @param {string|number} stationId 
 */
export function getEnergyData100C(stationId) {
  return request({
    url: `/dashboard/equipment/100C/main/getEnergyData`,
    method: 'get',
    params: {
      stationId
    }
  })
}


/**
 * 主监控-中间实时数据
 * @param {string|number} stationId 
 */
export function getRealtimeData100C(stationId) {
  return request({
    url: `/dashboard/equipment/100C/main/getRealtimeData`,
    method: 'get',
    params: {
      stationId
    }
  })
}


// 更新参数数据
/**
 * 更新参数数据
 * @param {object} data 
 * @param {string} data.uuid 设备UUID
 * @param {string} data.dataClassification
 * @param {Array<{nameEn: string}>} data.list
 * @returns 
 */
export function propertyUpdate(data) {
  return request({
    url: `/command/overseas/propertyUpdate`,
    method: 'post',
    data
  })
}
